import { RootState } from 'store'

export const horsesSelectors = {
  selectModerationCount: (state: RootState) => state.horses.moderationCount
}
